var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransparent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 142,
    height: 142,
    viewBox: "0 0 142 142",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.5029 131.015H95.6123H105.925H116.237H126.55H136.347V141.31H4.34668V87.2615H35.2842V131.015H44.5654V61.0095H75.5029V131.015ZM24.9717 131.015H14.6592V97.5565H24.9717V131.015ZM54.8779 71.3044H65.1904V131.015H54.8779V71.3044Z",
    fill: "#5C6B73"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137 103.883V60.4955C137 48.7836 126.388 45.2852 121.082 45H100.918C92.1401 45 85 51.9504 85 60.4955V103.883H95.0816V131H105.828V94.1184H96V61.1511C96 58.3108 98.3203 56 101.172 56H120.828C123.68 56 126 58.3108 126 61.1511V94.1184H116.172V131H126.918V103.883H137Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137 103.883V60.4955C137 48.7836 126.388 45.2852 121.082 45H100.918C92.1401 45 85 51.9504 85 60.4955V103.883H95.0816V131H105.828V94.1184H96V61.1511C96 58.3108 98.3203 56 101.172 56H120.828C123.68 56 126 58.3108 126 61.1511V94.1184H116.172V131H126.918V103.883H137Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137 103.883V104.633H137.75V103.883H137ZM121.082 45L121.122 44.2511L121.102 44.25H121.082V45ZM85 103.883H84.25V104.633H85V103.883ZM95.0816 103.883H95.8316V103.133H95.0816V103.883ZM95.0816 131H94.3316V131.75H95.0816V131ZM105.828 131V131.75H106.578V131H105.828ZM105.828 94.1184H106.578V93.3684H105.828V94.1184ZM96 94.1184H95.25V94.8684H96V94.1184ZM126 94.1184V94.8684H126.75V94.1184H126ZM116.172 94.1184V93.3684H115.422V94.1184H116.172ZM116.172 131H115.422V131.75H116.172V131ZM126.918 131V131.75H127.668V131H126.918ZM126.918 103.883V103.133H126.168V103.883H126.918ZM136.25 60.4955V103.883H137.75V60.4955H136.25ZM121.041 45.7489C123.586 45.8857 127.419 46.7993 130.594 49.0726C133.736 51.322 136.25 54.9077 136.25 60.4955H137.75C137.75 54.3714 134.958 50.352 131.467 47.8529C128.01 45.3777 123.884 44.3995 121.122 44.2511L121.041 45.7489ZM100.918 45.75H121.082V44.25H100.918V45.75ZM85.75 60.4955C85.75 52.3835 92.5351 45.75 100.918 45.75V44.25C91.745 44.25 84.25 51.5173 84.25 60.4955H85.75ZM85.75 103.883V60.4955H84.25V103.883H85.75ZM95.0816 103.133H85V104.633H95.0816V103.133ZM95.8316 131V103.883H94.3316V131H95.8316ZM105.828 130.25H95.0816V131.75H105.828V130.25ZM105.078 94.1184V131H106.578V94.1184H105.078ZM96 94.8684H105.828V93.3684H96V94.8684ZM95.25 61.1511V94.1184H96.75V61.1511H95.25ZM101.172 55.25C97.909 55.25 95.25 57.8936 95.25 61.1511H96.75C96.75 58.7279 98.7316 56.75 101.172 56.75V55.25ZM120.828 55.25H101.172V56.75H120.828V55.25ZM126.75 61.1511C126.75 57.8936 124.091 55.25 120.828 55.25V56.75C123.268 56.75 125.25 58.7279 125.25 61.1511H126.75ZM126.75 94.1184V61.1511H125.25V94.1184H126.75ZM116.172 94.8684H126V93.3684H116.172V94.8684ZM116.922 131V94.1184H115.422V131H116.922ZM126.918 130.25H116.172V131.75H126.918V130.25ZM126.168 103.883V131H127.668V103.883H126.168ZM137 103.133H126.918V104.633H137V103.133Z",
    fill: "url(#paint1_linear)",
    mask: "url(#path-2-inside-1)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.46 40.394C120.021 40.394 126.984 33.431 126.984 24.8703C126.984 16.3096 120.021 9.34662 111.46 9.34662C102.9 9.34662 95.9365 16.3096 95.9365 24.8703C95.9365 33.431 102.9 40.394 111.46 40.394ZM111.46 19.6957C114.313 19.6957 116.635 22.017 116.635 24.8703C116.635 27.7236 114.313 30.0449 111.46 30.0449C108.607 30.0449 106.286 27.7236 106.286 24.8703C106.286 22.017 108.607 19.6957 111.46 19.6957Z",
    fill: "url(#paint2_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 85,
    y1: 88,
    x2: 144.556,
    y2: 106.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEA860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA6661"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 85,
    y1: 88,
    x2: 144.556,
    y2: 106.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEA860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA6661"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 95.9365,
    y1: 24.8703,
    x2: 126.984,
    y2: 40.394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEA860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA6661"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 141.3,
    height: 141.3,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransparent);
export default __webpack_public_path__ + "static/media/transparent.124185ae3cf65cdef417a8a16f18a453.svg";
export { ForwardRef as ReactComponent };